import { __extends } from "tslib";
import { ErrorBase } from './ErrorBase';
/**
 * AbstractMethodError is thrown when an abstract method is called. The method in question should be overridden
 * by a concrete subclass.
 */
var PartialImplementationError = /** @class */ (function (_super) {
    __extends(PartialImplementationError, _super);
    /**
     * Create a new AbstractMethodError.
     * @param message An optional message to override the default error message.
     * @param id The id of the error.
     */
    function PartialImplementationError(dependency, id) {
        if (dependency === void 0) { dependency = ''; }
        if (id === void 0) { id = 0; }
        return _super.call(this, 'PartialImplementationError - this function is in development. Required Dependency: ' + dependency, id) || this;
    }
    return PartialImplementationError;
}(ErrorBase));
export { PartialImplementationError };
